import React from "react";
import Model from "../../common/Model";

const BannerForm = ({
  onClose,
  editId,
  handleSubmit,
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  loading,
  handleImageChange,
  preview,
}) => {
  return (
      <Model
        closeModal={onClose}
        title={`${editId ? "Edit" : "Add"} Banner`}
        isForm={true}
        loading={loading}
        handleSubmit={handleSubmit}
      >
        <div>
          <label className="text-sm font-medium text-foreground">
            Banner Image
          </label>
          <input
            type="file"
            name="image"
            onChange={handleImageChange}
            className="w-full px-4 py-2 border border-border rounded-xl"
          />
          {touched.image && errors.image && (
            <div className="text-red-500 text-sm">{errors.image}</div>
          )}
          {preview && (
            <div className="mt-4 flex">
              <p className="text-md text-foreground me-3">Preview:</p>
              <img
                src={preview}
                alt="preview"
                className="w-24 h-24 object-cover border border-border rounded-xl"
              />
            </div>
          )}
        </div>
        <div className="mt-3">
          <label className="text-sm font-medium text-foreground">
            Banner Type
          </label>
          <select
            name="type"
            className="w-full px-4 py-2 border border-border rounded-xl"
            value={values.type}
            onChange={handleChange}
            onBlur={handleBlur}
          >
            <option value="home">Home</option>
            <option value="results">Result</option>
          </select>

          {touched.type && errors.type && (
            <div className="text-red-500 text-sm">{errors.type}</div>
          )}
        </div>
        <div className="mt-3">
          <label className="text-sm font-medium text-foreground">Link</label>
          <input
            type="text"
            name="link"
            className="w-full px-4 py-2 border border-border rounded-xl"
            value={values.link}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Banner Link"
          />
          {touched.link && errors.link && (
            <div className="text-red-500 text-sm">{errors.link}</div>
          )}
        </div>
      </Model>
  );
};

export default BannerForm;
